if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.section;
        this.button = this.querySelector('.sticky-atc__button');
        this.label = this.querySelector('.sticky-atc__label');
        this.spinner = this.querySelector('.loading__spinner');
        this.input = this.querySelector('.quantity__input');
        this.price = this.querySelector('.sticky-atc__price');
      }

      quantityUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.productInfo = this.closest('product-info') || document;

        this.button.addEventListener('click', () => this.mainButton?.click());

        if (this.input) {
          this.querySelectorAll('.quantity__button').forEach((button) =>
            button.addEventListener('click', (event) => {
              event.preventDefault();
              this.mainQuantity?.querySelector(`.quantity__button[name='${button.name}']`)?.click();
            })
          );

          this.input.addEventListener('change', () => {
            const mainInput = this.mainInput;
            if (!mainInput) return;
            mainInput.value = this.input.value;
            mainInput.dispatchEvent(new Event('change', { bubbles: true }));
            this.syncQuantity();
          });

          this.onMainQuantityChange = (event) => {
            if (event.target === this.mainInput) this.syncQuantity();
          };
          this.productInfo.addEventListener('change', this.onMainQuantityChange);
          this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.syncQuantity());
          this.syncQuantity();
        }

        this.observeMainButton();
        this.observeMainPrice();
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
        if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
        if (this.onMainQuantityChange) this.productInfo.removeEventListener('change', this.onMainQuantityChange);
      }

      get mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      get mainQuantity() {
        return document.querySelector(`#Quantity-Form-${this.sectionId} quantity-input`);
      }

      get mainInput() {
        return document.getElementById(`Quantity-${this.sectionId}`);
      }

      observeMainButton() {
        const mainButton = this.mainButton;
        if (!mainButton) {
          this.hidden = true;
          return;
        }

        this.syncButton();
        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      observeMainPrice() {
        const mainPrice = document.getElementById(`price-${this.sectionId}`);
        if (!this.price || !mainPrice) return;

        this.priceObserver = new MutationObserver(() => this.syncPrice(mainPrice));
        this.priceObserver.observe(mainPrice, { childList: true, subtree: true, characterData: true });
      }

      syncPrice(mainPrice) {
        this.price.innerHTML = mainPrice.innerHTML;
        this.price.querySelectorAll('.price--large').forEach((price) => price.classList.remove('price--large'));
      }

      syncButton() {
        const mainButton = this.mainButton;
        if (!mainButton) return;

        const isLoading = mainButton.classList.contains('loading');
        this.button.disabled = mainButton.disabled;
        this.button.classList.toggle('loading', isLoading);
        this.button.toggleAttribute('aria-disabled', mainButton.getAttribute('aria-disabled') === 'true');
        this.spinner?.classList.toggle('hidden', !isLoading);

        const mainLabel = mainButton.querySelector(':scope > span:not(.hidden)');
        if (mainLabel) this.label.textContent = mainLabel.textContent.trim();
      }

      syncQuantity() {
        const mainInput = this.mainInput;
        if (!mainInput || !this.input) return;

        this.input.value = mainInput.value;
        ['min', 'max', 'step'].forEach((attribute) => {
          if (mainInput.hasAttribute(attribute)) {
            this.input.setAttribute(attribute, mainInput.getAttribute(attribute));
          } else {
            this.input.removeAttribute(attribute);
          }
        });

        const mainQuantity = this.mainQuantity;
        this.querySelectorAll('.quantity__button').forEach((button) => {
          const mainControl = mainQuantity?.querySelector(`.quantity__button[name='${button.name}']`);
          button.classList.toggle('disabled', mainControl?.classList.contains('disabled') ?? false);
        });
      }
    }
  );
}
